var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Content", prop: "content" } },
            [
              _c("el-input", {
                ref: "body",
                attrs: { type: "textarea", autosize: { minRows: 4 } },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
              _vm._v(" "),
              _c(
                "placeholders",
                {
                  attrs: { items: _vm.placeholders },
                  on: { select: _vm.addPlaceholder },
                },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { content: "Placeholders", placement: "top" } },
                    [
                      _c(
                        "span",
                        { staticClass: "color--prpl cursor-pointer" },
                        [_c("i", { staticClass: "fas fa-code" })]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Brands", prop: "brands" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-100",
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.form.brands,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "brands", $$v)
                    },
                    expression: "form.brands",
                  },
                },
                _vm._l(_vm.brandList, function (option) {
                  return _c(
                    "el-option",
                    _vm._b({ key: option.value }, "el-option", option, false)
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Tags", prop: "tags" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-100",
                  attrs: { multiple: "", filterable: "" },
                  model: {
                    value: _vm.form.tags,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tags", $$v)
                    },
                    expression: "form.tags",
                  },
                },
                _vm._l(_vm.tagList, function (option) {
                  return _c(
                    "el-option",
                    _vm._b({ key: option.value }, "el-option", option, false)
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-purple px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }